import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getToken } from "../../utils/utils";

/* LISTAGEM */
export const fetchProject = createAsyncThunk(
  "fetchProject",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/project/list.php?page=" +
      data.page +
      "&limit=" +
      data.limit;
    const authorization = getToken();
    const options = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      data,
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

/* BUSCA */
export const fetchProjectSearch = createAsyncThunk(
  "fetchProjectSearch",
  async (query, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      `/controller/project/search.php?search=${query}`;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.project;
        } else {
          return "Error";
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

/* DETALHES PARA EDIÇÃO */
export const fetchProjectEdit = createAsyncThunk(
  "fetchProjectEdit",
  async ({ id }, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      `/controller/project/details.php?id=${id}`;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.project[0];
        } else {
          return "Error";
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

/* CRIAÇÃO */
export const saveProject = createAsyncThunk(
  "saveProject",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/project/create.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
        "Content-Type": "multipart/form-data",
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.project) return result.data.project;
          else return result.data.message;
        } else {
          return "Error";
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

/* ATUALIZAÇÃO */
export const editProject = createAsyncThunk(
  "editProject",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/project/update.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
        "Content-Type": "multipart/form-data",
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.project) return result.data.project;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

/* EXCLUSÃO */
export const deleteProject = createAsyncThunk(
  "deleteProject",
  async (id, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + `/controller/project/delete.php?id=${id}`;
    const authorization = getToken();
    const options = {
      method: "delete",
      headers: { Authorization: "Bearer " + authorization },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        return result.status;
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
